import { Form, Input, Popover } from 'antd'
import { useTranslation } from 'react-i18next';

const TRUNCATE_LENGTH = 50

const InputForm = (props) => {
    const { t } = useTranslation();
    const { values, disabled = false, parent = "", tableLabel = "", label = "" } = props
    let currentValue = values?.[props.id] || ""

    if (disabled) {
        const text = currentValue == null ? '' : String(currentValue)
        const isLong = text.length > TRUNCATE_LENGTH
        const truncated = isLong ? text.slice(0, TRUNCATE_LENGTH) + '...' : text
        const popoverContent = (
            <div style={{ width: 360, maxHeight: '60vh', overflowY: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word', padding: "12px" }}>
                <div style={{ fontWeight: "600", fontSize: "16px" }}>{label || 'Details'}</div>
                {text}
            </div>
        )
        return (
            <span>
                {truncated}
                {isLong && (
                    <Popover
                        content={popoverContent}
                        trigger="click"
                        placement="topLeft"
                        styles={{ body: { padding: 16 } }}
                    >
                        <span
                            role="button"
                            tabIndex={0}
                            onClick={(e) => e.stopPropagation()}
                            style={{ marginLeft: 6, color: '#1677ff', cursor: 'pointer', textDecoration: 'underline' }}
                        >
                            {t('View More')}
                        </span>
                    </Popover>
                )}
            </span>
        )
    }

    return (
        <>
            <Form.Item label="" preserve={false} style={{ marginBottom: 0 }}>
                <Input value={currentValue} disabled={disabled} onChange={(e) => props.handleChange(props.id, e.target.value, props.documentId)} />
            </Form.Item>
        </>
    )
}

export default InputForm
